module.exports = __webpack_public_path__ + "img/more-fruit-icon-white.85dc187b.svg";